import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type LessonPlanSectionFormData} from './types';

interface ShowActionPayload {
    onSubmit: (formData: LessonPlanSectionFormData) => void;
    onDelete?: () => void;
    headerText?: string;
    submitButtonText?: string;
    initialValues?: LessonPlanSectionFormData;
}

const domain = 'MODALS/LESSON_PLAN_SECTION';

export const {action: show} = createAction(`${domain}/SHOW`, (payload: ShowActionPayload) => payload);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
